import styled from "styled-components";

export const CheckboxStyled = styled.input.attrs({ type: "checkbox" })`
  appearance: none;

  position: relative;
  cursor: pointer;

  background: white;

  width: 16px;
  height: 16px;

  border-radius: 2px;
  border: none;

  flex-shrink: 0;

  &::before {
    content: "✓";

    position: absolute;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    font-size: 14px;
    font-weight: bold;

    color: white;
    opacity: 0;

    transition: opacity 0.2s ease;
  }

  &:checked {
    background: var(--orange-primary);

    &::before {
      opacity: 1;
    }
  }

  ${({ $customStyles }) => $customStyles && $customStyles}
`;
